import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PreloaderColor } from '@enums/shared.enum';
import { VehicleModels } from '@models/vehicle.model';
import { UiKitModule } from '../ui-kit.module';
import { NgIf } from '@angular/common';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';
import { MatMenu, MatMenuItem } from '@angular/material/menu';
import { UiPreloaderComponent } from '../ui-preloader/ui-preloader.component';
import { ThumbnailsService } from '../../../development/thumbnails.service';
import { StorageBucket } from '@consts/storage-url.util';
import { UiSnapshotComponent } from "@ui";

@Component({
  selector: 'ui-vehicle-icon',
  templateUrl: './ui-vehicle-icon.component.html',
  styleUrls: ['./ui-vehicle-icon.component.scss'], imports: [UiKitModule, MatTooltip, NgIf, MatIcon, MatMenu, MatMenuItem, UiSnapshotComponent, UiPreloaderComponent],
})
export class UiVehicleIconComponent implements OnInit {
  public PreloaderColor = PreloaderColor;

  @Output() add = new EventEmitter<void>();
  @Output() addExisting = new EventEmitter<void>();
  @Output() delete = new EventEmitter<void>();

  @Input() vehicle: VehicleModels.Vehicle;
  @Input() small = false;
  @Input() allowDelete = false;

  imgSrc = '';

  public imageLoaded = false;
  public imageError = false;

  constructor(private thumbnailsService: ThumbnailsService, private cd: ChangeDetectorRef) {}

  ngOnInit(): void {
    const vehicle = this.vehicle;
    if (vehicle.bestImage) {
      const base = this.thumbnailsService.getBucketBaseUrl(StorageBucket.TrainingThumbnails, true, false, vehicle.edgeId);
      this.imgSrc = `${base}/crop/${vehicle.edgeId}/${vehicle.cameraId}/${vehicle.bestImage}`;
    }
  }

  public load(success: boolean) {
    if (success) {
      this.imageLoaded = true;
    } else {
      this.imageError = true;
    }
    this.cd.detectChanges();
  }
}
